import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { EnvioDocumentoTracesEditComponent } from './documentostraces/enviodocumentotraces-edit.component';
import { EnvioDocumentoTracesListComponent } from './documentostraces/enviodocumentotraces-list.component';
import { EnvioAduanasEditComponent } from './enviosaduanas/envioaduana-edit.component';
import { EnvioAduanaListComponent } from './enviosaduanas/envioaduana-list.component';
import { EnvioAduanasV3EditComponent } from './enviosaduanasv3/envioaduanav3-edit.component';
import { EnvioAduanaV3ListComponent } from './enviosaduanasv3/envioaduanav3-list.component';
import { EnvioEphytoEditComponent } from './enviosephyto/envioephyto-edit.component';
import { EnvioEphytoListComponent } from './enviosephyto/envioephyto-list.component';
import { EnvioTracesEditComponent } from './enviostraces/enviotraces-edit.component';
import { EnvioTracesListComponent } from './enviostraces/enviotraces-list.component';
import { SeriLogWrapperComponent } from './serilog/serilog-wrapper/serilog-wrapper.component';
import { SeriLogWrapperEditComponent } from './serilog/serilog-wrapper-edit/serilog-wrapper-edit.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';

const enviosRoutes = [
    //ENVIOS ADUANAS
    {
        path: 'mantenimiento/envios/aduanas',
        data: {
            breadcrumb: 'Envíos Aduanas',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: EnvioAduanaListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EnvioAduanasEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Envío Aduanas',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //ENVIOS ADUANAS V3
    {
        path: 'mantenimiento/envios/aduanasv3',
        data: {
            breadcrumb: 'Envíos Aduanas V3',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: EnvioAduanaV3ListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EnvioAduanasV3EditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Envío Aduanas V3',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //ENVIOS TRACES
    {
        path: 'mantenimiento/envios/traces',
        data: {
            breadcrumb: 'Envíos Traces',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: EnvioTracesListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EnvioTracesEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Envío Traces',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //ENVIOS EPHYTO
    {
        path: 'mantenimiento/envios/ephyto',
        data: {
            breadcrumb: 'Envíos Ephyto',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: EnvioEphytoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EnvioEphytoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Envío Ephyto',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //ENVIOS DOCUMENTO TRACES
    {
        path: 'mantenimiento/envios/documentostraces',
        data: {
            breadcrumb: 'Envíos Documento Traces',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: EnvioDocumentoTracesListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: EnvioDocumentoTracesEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Envío Documento Traces',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },

    //LOG
    {
        path: 'mantenimiento/envios/serilog',
        data: {
            breadcrumb: 'Log',
            menu0: 'MANTENIMIENTO',
            menu1: 'General',
        },
        children: [
            {
                path: '',
                component: SeriLogWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
            {
                path: 'edit/:id',
                component: SeriLogWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Detalle',
                    actionCode: EnumCodigosTwTcAcciones.MANTENIMIENTOS,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(enviosRoutes)],
    exports: [RouterModule],
})
export class EnviosRoutingModule {}
